import { reactive, onMounted, onBeforeUnmount } from "vue";

/** 移动端尺寸使用50px作为base缩放，PC端尺寸使用50px做为固定base */
export default function useRem(
  ratio: number = 2,
  maxWidth: number = 1360,
  maxFontSize: number = 50,
) {
  const state = reactive({ isMobile: false, isPC: true });
  const resize = () => {
    const docEl = document.documentElement;
    let width = docEl.getBoundingClientRect().width;
    width = Math.min(width, maxWidth);
    const rem = (width * 100) / (375 * ratio);
    const finalRem = Math.min(rem, maxFontSize);
    if (width >= maxWidth) {
      state.isMobile = false;
      state.isPC = true;
      docEl.style.fontSize = finalRem + "px";
    } else {
      state.isMobile = true;
      state.isPC = false;
      docEl.style.fontSize =
        (rem <= maxFontSize ? rem : Math.max(maxFontSize, rem * 0.5)) + "px";
    }
  };
  onMounted(() => {
    resize();
  });

  window.addEventListener("resize", resize);
  onBeforeUnmount(() => {
    window.removeEventListener("resize", resize);
  });
  return state;
}
